/*
 * 这里是为了做性能优化，将index.html中要加载的一部分内容拿到这里，判断是否运行在iframe中，是的话可以部分服用顶层window
 */
import Vue from 'vue'
// import { getBaseUrl } from '@/utils/common'

window.__number_round_down = function (num) {
  num = num || 0
  if (typeof num != 'number') {
    console.error("__number_round_down 方法入参必须是Nunber类型，当前传入的类型是" + typeof num)
    return
  }
  if (typeof this == 'undefined') {
    console.error("__number_round_down 方法调用对象只能是Number类型")
    return 
  }
  var numStr = this.toString()
  var hasDecimal = numStr.includes('.')
  if (!hasDecimal) {
    // 如果没有小数点，直接返回原数字
    return parseFloat(numStr)
  }
  var arr = numStr.split('.')
  // 截取小数位
  var truncatedDecimal = arr[1].substring(0, num)
  // 重新组合数字字符串
  var truncatedNumStr = arr[0] + '.' + truncatedDecimal
  return parseFloat(truncatedNumStr)
}

/*
 * url: 要加载的资源url
 * loadedCallback: 该资源load完之后需要执行的load callback
 * unloadPollyfill: 该资源不需要加载的话，可能需要执行一些垫片操作，以防止在iframe中执行报错
 * checkBeforeLoad: 判断该资源是否需要加载（极致场景的优化，有些重要页面不需要的一些功能就可以不加载）返回true代表加载，返回false代表不要加载
 */
var urlList = [
  {
    url: '//static.ymm56.com/common-lib/xe-utils/v3.5.30/xe-utils.umd.min.js',
    loadedCallback: () => {
      Number.prototype.toFixed = function (num) {
        var that = this
        return window.XEUtils.toFixed(that, num)
      }
      // 添加舍弃模式，如 0.12349使用舍弃模式保留4位小数结果是 0.1234 而不是0.1235
      Number.prototype.toRoundDown = function (num) {
        var that = this
        return window.__number_round_down.call(that, num)
      }
      Vue.prototype.XEUtils = window.XEUtils
    },
    unloadPollyfill: () => {
      window.XEUtils = top.XEUtils
      Number.prototype.toFixed = function (num) {
        var that = this
        return window.XEUtils.toFixed(that, num)
      }
      // 添加舍弃模式，如 0.12349使用舍弃模式保留4位小数结果是 0.1234 而不是0.1235
      Number.prototype.toRoundDown = function (num) {
        var that = this
        return window.__number_round_down.call(that, num)
      }
      Vue.prototype.XEUtils = window.XEUtils
    },
    checkBeforeLoad: () => {
      if (!window.isInIframe()) {
        return true
      }
      // top上如果加载失败，iframe中复用不了，需要加载
      if (!top.XEUtils) {
        return true
      }
      return false
    }
  },
  {
    url: '//static.ymm56.com/lq-common-lib/custom/v1/pinyin/convertPinyin.js',
    unloadPollyfill: () => {
      window.convertPinyin = top.convertPinyin
    },
    checkBeforeLoad: () => {
      if (!window.isInIframe()) {
        return true
      }
      if (!top.convertPinyin) {
        return true
      }
      return false
    }
  },
  {
    url: 'https://static.ymm56.com/lib-track/2.7.3/index.js',
    unloadPollyfill: () => {
      window.lib = top.lib
    },
    checkBeforeLoad: () => {
      if (!window.isInIframe()) {
        return true
      }
      // top上如果加载失败，iframe中复用不了，需要加载
      if (!top.lib || !top.lib.track) {
        return true
      }
      return false
    },
    loadedCallback: () => {
      window.lib &&
        window.lib.track.init({
          appType: 13,
          env: window.__lq__lib_track__api.env || 'prod',
          appId: 'lq-saas-web',
          userId: window.locaUser.TMSCode || '0',
          loginsite: window.locaUser.loginsite || '0',
          browserName: window.browserInfo && window.browserInfo.browser,
          browserVersion: window.browserInfo && window.browserInfo.version,
          adminName: window.locaUser.adminname,
          userName: window.locaUser.UserName,
          autopageview: 0,
          autoHubbleLog: window.locaUser.TMSCode == '90100' || window.locaUser.TMSCode == '82635' ? true : false,
          pageNameHandler: window.__lq__lib_track__api.pageNameHandler,
          company_id: window.locaUser.TMSCode || '0'
        })
    }
  },
  {
    url: '//static.ymm56.com/lq-common-lib/combined/export/v1.2/export-excel-combined.js',
    loadDelayTime: location.pathname.indexOf('/Billing/Index') != -1 ? 5000 : 0,
    noDefer: true // 非阻塞是加载， 用户不会一进页面立马导出，可后置加载
  }
]


// 校验是否复用
export function checkReuseResource(finalCallback) {
  // debugger
  function loadScript(url, callback, next, item) {
    var script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    script.crossOrigin = null  // 确保不设置 crossorigin
    script.referrerPolicy = 'no-referrer'  // 避免发送 origin 头

    script.onload = function () {
      typeof callback == 'function' && callback()
      !item.noDefer && next()
    }
    script.onerror = function () {
      !item.noDefer && next()
    }
    if (item.loadDelayTime && item.loadDelayTime > 0) {
      setTimeout(() => {
        document.body.appendChild(script)
      }, item.loadDelayTime)
    } else {
      document.body.appendChild(script)
    }
    if (item.noDefer) {
      next()
    }
  }

  function next() {
    if (urlList.length == 0) {
      finalCallback()
    } else {
      const item = urlList.shift()
      const unloadPollyfill = item.unloadPollyfill
      const checkBeforeLoad = item.checkBeforeLoad
      try {
        if (!checkBeforeLoad || !checkBeforeLoad()) {
          // 不加载资源 复用
          unloadPollyfill()
          next()
        } else {
          loadScript(item.url, item.loadedCallback, next, item)
        }
      } catch (error) {
        loadScript(item.url, item.loadedCallback, next, item)
      }
    }
  }

  // 开始递归 next
  next()
}
